const SET_MOBILE_LAYOUT = 'setMobileLayout'
const obj = { SET_MOBILE_LAYOUT }
export default obj
